import React from "react";

export default function ExamRules() {
return ( <div style={pageStyle}> <div style={overlayStyle}> <div style={cardStyle}>

      {/* LOGO */}
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <img src="/logo.png" alt="EduAt10" style={{ width: 120 }} />
      </div>

      <h1 style={titleStyle}>
        Scholarship Exam Rules & Regulations
      </h1>

      {/* ================= ENGLISH ================= */}
      <h3 style={subStyle}>English</h3>

      <p style={textStyle}>
        1. Every student must register individually to participate in any Scholarship
        or Mega Scholarship Exam conducted by EduAt10.
      </p>

      <p style={textStyle}>
        2. Registration will be considered valid only after successful payment
        of the prescribed exam fee.
      </p>

      <p style={textStyle}>
        3. Students must attempt the exam within the scheduled time. If a student
        fails to appear or complete the exam on time, EduAt10 will not be responsible.
      </p>

      <p style={textStyle}>
        4. Ranking will be decided based on highest score. In case of equal score,
        the student who completes the exam in lesser time will be ranked higher.
      </p>

      <p style={textStyle}>
        5. The student securing 1st rank will be declared Winner.
      </p>

      <p style={textStyle}>
        6. Next top 10 ranked students will receive prize amounts as per predefined
        distribution.
      </p>

      <p style={textStyle}>
        7. Winning amount will be given only one time per exam.
      </p>

      <p style={textStyle}>
        8. EduAt10 reserves the right to verify results before announcing winners.
      </p>

      <p style={textStyle}>
        9. Participation in the exam implies acceptance of all rules and regulations.
      </p>

      {/* ================= HINDI ================= */}
      <h3 style={subStyle}>हिंदी</h3>

      <p style={textStyle}>
        1. प्रत्येक छात्र को EduAt10 द्वारा आयोजित किसी भी Scholarship या
        Mega Scholarship परीक्षा में भाग लेने के लिए स्वयं पंजीकरण करना
        अनिवार्य है।
      </p>

      <p style={textStyle}>
        2. परीक्षा शुल्क का सफल भुगतान होने के बाद ही पंजीकरण मान्य माना जाएगा।
      </p>

      <p style={textStyle}>
        3. छात्र को निर्धारित समय में परीक्षा देनी होगी। यदि छात्र समय पर परीक्षा
        नहीं देता या पूर्ण नहीं कर पाता है, तो इसके लिए EduAt10 जिम्मेदार नहीं होगा।
      </p>

      <p style={textStyle}>
        4. रैंकिंग उच्चतम अंक के आधार पर तय होगी। यदि अंक समान होते हैं,
        तो कम समय में परीक्षा पूर्ण करने वाले छात्र को उच्च रैंक मिलेगी।
      </p>

      <p style={textStyle}>
        5. प्रथम स्थान प्राप्त करने वाला छात्र विजेता घोषित किया जाएगा।
      </p>

      <p style={textStyle}>
        6. उसके बाद के शीर्ष 10 छात्रों को पूर्व निर्धारित राशि प्रदान की जाएगी।
      </p>

      <p style={textStyle}>
        7. विजेता राशि प्रत्येक परीक्षा के लिए केवल एक बार दी जाएगी।
      </p>

      <p style={textStyle}>
        8. परिणाम घोषित करने से पहले EduAt10 सत्यापन करने का अधिकार सुरक्षित रखता है।
      </p>

      <p style={textStyle}>
        9. परीक्षा में भाग लेना इन सभी नियमों और शर्तों की स्वीकृति माना जाएगा।
      </p>

    </div>
  </div>
</div>


);
}

/* ================= STYLES ================= */

const pageStyle = {
minHeight: "100vh",
backgroundImage: "url('/eduat10-bg.png')",
backgroundSize: "cover",
backgroundPosition: "center",
};

const overlayStyle = {
minHeight: "100vh",
backgroundColor: "rgba(0,0,0,0.25)",
padding: 30,
};

const cardStyle = {
maxWidth: 900,
margin: "auto",
background: "rgba(255,255,255,0.95)",
borderRadius: 16,
padding: 30,
lineHeight: 1.7,
};

const titleStyle = {
fontSize: 24,
fontWeight: "800",
marginBottom: 16,
};

const subStyle = {
fontSize: 18,
fontWeight: "700",
marginTop: 14,
};

const textStyle = {
fontSize: 15,
marginTop: 6,
};
